import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const orderApi = createApi({
  reducerPath: 'orderApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_EVENT}`,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['Order', 'Commissions'],
  endpoints: (builder) => ({
    generateOrder: builder.mutation({
      query: (body) => ({
        url: 'checkout-bookings/api/v1/generate-booking',
        method: 'POST',
        body,
      }),
      providesTags: ['Order'],
    }),
    payOrder: builder.mutation({
      query: (body) => ({
        url: 'checkout-bookings/api/v1/generate-payment',
        method: 'POST',
        body,
      }),
    }),
    verifyPaymentStatus: builder.mutation({
      query: (body) => ({
        url: 'checkout-bookings/api/v1/verify-payment-status',
        method: 'POST',
        body,
      }),
    }),
    getBookingInfo: builder.mutation({
      query: (body) => ({
        url: 'checkout-bookings/api/v1/information',
        method: 'POST',
        body,
      }),
    }),
    changeStatus: builder.mutation({
      query: (body) => ({
        url: 'checkout-bookings/api/v1/change-status',
        method: 'PUT',
        body,
      }),
    }),
    generateBookingsPdf: builder.mutation({
      query: (body) => ({
        url: 'checkout-bookings-broker/api/v1/generate-bookings-pdf',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGenerateOrderMutation,
  useGetBookingInfoMutation,
  useChangeStatusMutation,
  usePayOrderMutation,
  useVerifyPaymentStatusMutation,
  useGenerateBookingsPdfMutation,
} = orderApi;
